// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { CautionSign } from 'components/shared/CautionSign/CautionSign'
import { SequenceNumber } from './common/SequenceNumber/SequenceNumber'
import { Status } from './common/Status/Status'

import styles from './TabContent.module.scss'

export const TabContent = ({
  className = undefined,
  label,
  sequenceNumber,
  isActive,
  isDisabled,
  isFinished,
  isInvalid,
  caution = 0,
}) => (
  <span className={cx(styles.content, { [className]: Boolean(className) })}>
    {sequenceNumber ? (
      <SequenceNumber {...{ sequenceNumber, isActive, isDisabled }} />
    ) : null}
    <span
      className={cx(styles.label, {
        [styles.disabled]: isDisabled,
        [styles.active]: isActive,
        [styles.invalid]: isInvalid,
      })}
    >
      {label}
    </span>
    <CautionSign className={styles.caution} count={caution} placement="bottom" />
    <Status {...{ isFinished, isInvalid }} />
  </span>
)
